<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850"
  [nzVisible]="isVisibleProfileDrawer" nzTitle="My Profile" [nzFooter]="footerTpl" (nzOnClose)="handleCancel()">
  <div *nzDrawerContent>
    <div nzXs="24" nzSm="24" nzMd="10" nzLg="10" nzXl="10">
      <div class="upload mb-2">
        <nz-avatar (click)="file.click()" (change)="onFileChanged($event)" class="cursor user-profile"
          [nzSize]="150" [nzText]="userInitials" [nzSrc]="this.uploadResult ? this.uploadResult : null">
        </nz-avatar>
        <input autocomplete="off" type="file" (change)="onFileChanged($event)" #file hidden nzTooltipTitle="prompt text"
          multiple accept="image/png, image/jpg, image/jpeg" />

        <a *ngIf="this.uploadResult" nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to delete your profile picture?" nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="removeLogo()"><img src="../../../../assets/images/delete.png" class="delete-File ml-1" />
        </a>
      </div>
    </div>
    <form nz-form [formGroup]="_fS.profileForm" class="section-top-padding">
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="firstNameError">
              <label class="label-text required">First name</label>
              <input type="text" (keypress)="_cs.checkAlphabetsWithSpace($event)" class="input-group"
                formControlName="firstName" nz-input maxlength="50" minlength="2">
              <ng-template #firstNameError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter first
                  name</ng-container>
                <ng-container *ngIf="control.hasError('minlength')">Role name must contain at least 2
                  characters</ng-container>
                <ng-container *ngIf="control.hasError('pattern')">Please enter first name</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="lastNameError">
              <label class="label-text required">Last name</label>
              <input type="text" (keypress)="_cs.checkAlphabets($event)" class="input-group" formControlName="lastName"
                nz-input maxlength="50" minlength="2">
              <ng-template #lastNameError let-control>
                <ng-container *ngIf="control.hasError('required')">Please enter last name</ng-container>
                <ng-container *ngIf="control.hasError('minlength')">Role name must contain at least 2
                  characters</ng-container>
                <ng-container *ngIf="control.hasError('pattern')">Please enter last name</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <app-phone-change-verify [control]="phoneControl" [savedPhoneNumber]="savedPhoneNumber"
            (verified)="onPhoneVerified($event)"></app-phone-change-verify>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-control>
              <label class="label-text">Title</label>
              <input type="text" (keypress)="_cs.checkAlphabetsWithSpaceCommaNumbers($event)" class="input-group"
                formControlName="title" nz-input maxlength="100" minlength="2">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="locationError">
              <label class="label-text">Location</label>
              <input type="text" (keypress)="_cs.checkAlphabetsWithSpaceCommaNumbers($event)" class="input-group"
                formControlName="location" nz-input maxlength="100" minlength="2">
              <ng-template #locationError let-control>
                <ng-container *ngIf="control.hasError('minlength')">Location must contain at least 2 characters</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="linkedInError">
              <div class="profile-label-row">
                <label class="label-text">LinkedIn URL</label>
                <a class="profile-verify-link" *ngIf="canVerifyLinkedIn" (click)="openLinkedIn()">Verify link
                  <span nz-icon nzType="export" nzTheme="outline"></span></a>
              </div>
              <input pattern="http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?" type="text" class="input-group"
                formControlName="linkedinUrl" nz-input>
              <ng-template #linkedInError let-control>
                <ng-container *ngIf="control.hasError('pattern')">Please enter a valid LinkedIn profile URL</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <nz-divider></nz-divider>
    <div nz-row [nzGutter]="8">
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="section-top-padding mr-4">
        <div class="d-flex align-i-c mb-1">
          <label class="profile-label-text">Email</label>
          <p class="profile-name pb-0 ml-2">{{userDetails?.email ? userDetails?.email : '-'}}</p>
        </div>
        <div class="d-flex align-i-c mb-1">
          <label class="profile-label-text">Role</label>
          <p class="profile-name pb-0 ml-2">{{userDetails?.role ? userDetails?.role : '-'}}</p>
        </div>
        <div class="d-flex mb-1">
          <label class="profile-label-text">Agency</label>

          <div class="profile-name pb-0 ml-2" *ngIf="userDetails?.role.toLowerCase() != 'Super Admin'.toLowerCase()">
            <nz-skeleton *ngIf="isLoading" [nzActive]="true" [nzParagraph]="{ rows: 1,width: 1}"></nz-skeleton>
            <ng-container *ngFor="let agency of userDetails?.agency;let i = index">
              <ng-container class="profile-name pb-0"> {{agency.name}}<span
                  *ngIf="(i+1) != userDetails?.agency.length">,</span></ng-container>
            </ng-container>
          </div>
          <p class="profile-name pb-0 ml-2" *ngIf="userDetails?.role.toLowerCase() == 'Super Admin'.toLowerCase()">
            ALL
          </p>
        </div>
        <div class="mb-1" [ngClass]="userDetails?.role.toLowerCase() == 'Super Admin'.toLowerCase() ? 'd-flex':null">
          <label class="profile-label-text">Sites</label>
          <nz-skeleton *ngIf="isLoading" [nzActive]="true" [nzParagraph]="{ rows: 1,width: 1}"></nz-skeleton>
          <div *ngIf="userDetails?.role.toLowerCase() != 'Super Admin'.toLowerCase()" class="section-top-padding">
            <div class="d-flex mb-1 mt" *ngFor="let account of userDetails?.siteAccountGroup">
              <div>
                <p class="profile-label-text label-text no-font-weight">{{account.parent.name}}:</p>
              </div>
              <div class="profile-name ml-2">
                <ng-container *ngFor="let site of account.children;let i = index">
                  <ng-container class="profile-name pb-0">
                    <a class="redirection-link" (click)="redirecToPaybev(site?._id)">{{site.Name}}</a><span
                      *ngIf="(i+1) != account.children.length">, </span></ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <p class="profile-name pb-0 ml-2" *ngIf="userDetails?.role.toLowerCase() == 'Super Admin'.toLowerCase()">
            ALL
          </p>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footerTpl>
    <div class="d-flex justify-content-end ">
      <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isUpdatingUser"
        [disabled]="_uiPhoneVerifyPending" class="medium-btn small-btn width-100 mr-1">Update</button>
      <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100">Cancel</button>
    </div>
  </ng-template>
</nz-drawer>